import { useState } from "react";
import FormErrors from "@sharpana/ui/FormErrors";
import { requestPasswordReset } from "../api_client/allauth";
import { Link } from "react-router-dom";
import Button from "@sharpana/ui/Button";
import {
  authContainer,
  authCard,
  formGroup,
  linkText,
} from "./styles";

export default function RequestPasswordReset() {
  const [email, setEmail] = useState("");
  const [response, setResponse] = useState({ fetching: false, content: null });

  function submit() {
    setResponse({ ...response, fetching: true });
    requestPasswordReset(email)
      .then((content) => {
        setResponse((r) => {
          return { ...r, content };
        });
      })
      .catch((e) => {
        console.error(e);
        window.alert(e);
      })
      .then(() => {
        setResponse((r) => {
          return { ...r, fetching: false };
        });
      });
  }

  if ((response as any).content?.status === 200) {
    return (
      <div className={authContainer}>
        <div className={authCard}>
          <h1>Reset Password</h1>
          <p>Password reset sent.</p>
        </div>
      </div>
    );
  }

  return (
    <div className={authContainer}>
      <div className={authCard}>
        <h1>Reset Password</h1>
        <p className={linkText}>
          Remember your password? <Link to="/account/login">Back to login.</Link>
        </p>

        <FormErrors errors={(response as any).content?.errors} />

        <div className={formGroup}>
          <label htmlFor="email">Email</label>
          <input
            id="email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            type="email"
            required
          />
          <FormErrors param="email" errors={(response as any).content?.errors} />
        </div>

        <Button
          style={{ width: "100%" }}
          disabled={response.fetching}
          onClick={() => submit()}
        >
          Reset Password
        </Button>
      </div>
    </div>
  );
}
